import React, { useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import styled from "@emotion/styled";
import { SelectButton, Loader, LegTypesWrapper } from "../StyledComponents";
import { ReactComponent as Check } from "../../svg/check.svg";
import { ReactComponent as Zoom } from "../../svg/zoom.svg";
import { replaceAll } from "../../App";

export const Materials = ({ selected, handleClick }) => {
  const [seamless, setSeamless] = useState(
    selected.textiles ? selected.textiles.seamless : false
  );
  const { loading, error, data } = useQuery(
    gql`
      query materials($id: Int!) {
        bedType(id: $id) {
          id
          seamless
          textiles {
            textileId
            title
            byobImages(id: $id) {
              url
              type
            }
            productThumbnail(version: "byob-textile") {
              url
              width
              height
            }
            headboardTextileFor {
              textileId
            }
            headboardTextiles(id: $id) {
              textileId
              title
              productThumbnail(version: "byob-textile") {
                url
                width
                height
              }
            }
          }
        }
      }
    `,
    { variables: { id: selected.bed.id, seamless: seamless } }
  );

  if (loading) return <Loader />;
  if (error) return <p>Error :(</p>;
  const items = data.bedType.textiles.filter((item) => {
    return !item.headboardTextileFor;
  });
  const has_seamless = data.bedType.seamless;

  const seam_fixer = (img, selected) => {
    if (!has_seamless || !seamless) {
      return img;
    }

    if (selected.bed.slug === "continental") {
      img = replaceAll(img, "Continental", "Continental_Seamless");
    }

    if (selected.bed.slug === "aqtive-ii") {
      img = replaceAll(img, "Aqtive_II", "Aqtive_II_Seamless");
    }

    if (selected.bed.slug === "aqtive-i") {
      img = replaceAll(img, "Aqtive_I", "Aqtive_I_Seamless");
    }

    if (selected.bed.slug === "dream") {
      img = replaceAll(img, "Dream", "Dream_Seamless");
    }
    return img;
  };

  return (
    <>
      {has_seamless && (
        <LegTypesWrapper>
          <button
            className={!seamless ? "active" : undefined}
            onClick={() => {
              setSeamless(false);
            }}
          >
            Split
          </button>
          <button
            className={seamless ? "active" : undefined}
            onClick={() => {
              setSeamless(true);
            }}
          >
            Seamless
          </button>
        </LegTypesWrapper>
      )}
      {items.map((item, i) => {
        const item_data = {
          id: item.textileId,
          title: item.title,
          hid: item.textileId,
          img: item.byobImages
            ? seam_fixer(item.byobImages.url, selected)
            : null,
          seamless: seamless,
        };

        return (
          <>
            <SelectButton
              className={
                selected.textiles &&
                parseInt(item.textileId) === selected.textiles.id &&
                selected.textiles.seamless === seamless &&
                parseInt(item.textileId) === selected.textiles.hid
                  ? "active"
                  : "inActive"
              }
              key={i}
              onClick={() => handleClick(item_data)}
            >
              <img
                loading="lazy"
                src={item.productThumbnail.url}
                alt=""
                height="90"
                width="90"
              />

              <ZoomModal item={item} />

              <h3>{item.title}</h3>
              <Check />
            </SelectButton>
            {item.headboardTextiles.map((hb) => (
              <SelectButton
                className={
                  selected.textiles &&
                  parseInt(item.textileId) === selected.textiles.id &&
                  selected.textiles.seamless === seamless &&
                  parseInt(hb.textileId) === selected.textiles.hid
                    ? "active"
                    : "inActive"
                }
                key={i}
                onClick={() =>
                  handleClick({
                    ...item_data,
                    hid: hb.textileId,
                  })
                }
              >
                <img
                  loading="lazy"
                  src={hb.productThumbnail.url}
                  alt=""
                  height="90"
                  width="90"
                />
                <ZoomModal item={item} />
                <h3>
                  {hb.title}
                  <span>{item.title}</span>
                </h3>

                <Check />
              </SelectButton>
            ))}
          </>
        );
      })}
    </>
  );
};

const ModalOverlay = styled("div")`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.3);
  z-index: 99;
  div {
    padding: 2rem;
    border-radius: 3px;
    max-width: 400px;
    background: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .closeBtn {
      position: absolute;
      top: 0rem;
      right: 0rem;
      width: 2rem;
      height: 2rem;
      padding: 0;
      text-align: center;
      line-height: center;
      border: none;
      background: transparent;
      font-size: 2rem;
    }
    img {
      margin-right: 0;
    }
    h4 {
      text-align: center;
      font-size: 1.5rem;
      margin: 1rem 0 0;
    }
  }
`;

const ZoomModal = ({ item }) => {
  const [open, setOpen] = useState(false);

  if (!item) return null;
  return (
    <>
      <Zoom
        className="zoomImage"
        onClick={() => {
          setOpen(true);
        }}
      />
      {open ? (
        <ModalOverlay>
          <div>
            <button
              className="closeBtn"
              onClick={() => {
                setOpen(false);
              }}
            >
              &times;
            </button>
            <img
              loading="lazy"
              src={item.productThumbnail.url}
              alt=""
              height="300"
              width="300"
            />
            <h4>{item.title}</h4>
          </div>
        </ModalOverlay>
      ) : null}
    </>
  );
};
